import { render } from "./RefreshButton.vue?vue&type=template&id=3bb672f9&scoped=true"
import script from "./RefreshButton.vue?vue&type=script&lang=js"
export * from "./RefreshButton.vue?vue&type=script&lang=js"

import "./RefreshButton.vue?vue&type=style&index=0&id=3bb672f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb672f9"]])

export default __exports__